export default "__VITE_ASSET__H7r4_HMQ__"